import { cn } from '@/lib/utils'
import { RetroButton } from './RetroButton'

interface SidebarProps {
  activeSection: string
  onNavigate: (section: string) => void
  isMobile?: boolean
}

const menuItems = [
  { id: 'sobre', label: 'Sobre o Banco' },
  { id: 'cotacao', label: 'Comprar Sucata' },
  { id: 'vender', label: 'Vender Material' },
  { id: 'materiais', label: 'Tipos de Materiais' },
  { id: 'logistica', label: 'Logística & Coleta' },
  { id: 'parceiros', label: 'Parceiros' },
  { id: 'contato', label: 'Contato' },
]

export const Sidebar = ({
  activeSection,
  onNavigate,
  isMobile,
}: SidebarProps) => {
  if (isMobile) {
    return (
      <div className="w-full bg-[#d4d4d4] border-b border-gray-500 overflow-x-auto">
        <div className="flex p-2 gap-2 min-w-max">
          {menuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => onNavigate(item.id)}
              className={cn(
                'px-4 py-2 text-sm font-serif font-bold border-2 rounded-md transition-all shadow-sm active:translate-y-px',
                activeSection === item.id
                  ? 'bg-blue-700 text-white border-blue-900 shadow-inner'
                  : 'bg-[#eeeeee] text-black border-gray-400 hover:bg-white',
              )}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>
    )
  }

  return (
    <nav className="w-64 bg-[#cccccc] flex flex-col py-6 px-4 gap-6 border-r border-gray-500 h-full overflow-y-auto custom-scrollbar shrink-0">
      {menuItems.map((item) => (
        <RetroButton
          key={item.id}
          variant="marble"
          label={item.label}
          isActive={activeSection === item.id}
          onClick={() => onNavigate(item.id)}
        />
      ))}
    </nav>
  )
}
